import { currentApiUrl } from "@guestflow/shared/env";

const API_URL = currentApiUrl();

export function apiFetch(path: string, options?: RequestInit): Promise<Response> {
  // Ensure path starts with /
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return fetch(`${API_URL}${normalizedPath}`, {
    ...options,
    credentials: "include",
  });
}

export const api = {
  get: (path: string) => apiFetch(path, { method: "GET" }),
  post: (path: string, body?: unknown) =>
    apiFetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body ? JSON.stringify(body) : undefined,
    }),
  patch: (path: string, body?: unknown) =>
    apiFetch(path, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: body ? JSON.stringify(body) : undefined,
    }),
  delete: (path: string) => apiFetch(path, { method: "DELETE" }),
};
